import { defineMessages } from 'react-intl';

export default {
  'vr-games': {
    language: defineMessages({
      title: {
        id: 'feature-search.vr-support.title',
        defaultMessage: 'Virtual Reality Games',
      },
      seoTitle: {
        id: 'feature-search.vr-support.seoTitle',
        defaultMessage: 'VR Steam PC Games - Virtual Reality',
      },
      seoDesc: {
        id: 'feature-search.vr-support.seoDesc',
        defaultMessage: 'Get massive savings on Steam VR games and Bundles. Deals updated daily',
      },
      paragraph: {
        id: 'feature-search.vr-support.paragraph',
        defaultMessage: 'What better way to immerse yourself within your favorite game worlds than to head in via Virtual Reality. VR games offer a whole new perspective to enjoy, letting you step into the shoes of the brave hero or adventurer, quite literally! So grab your headset and your controllers and get ready to go beyond the screen with some of the best awe-inspiring, VR-focused titles on the market.',
      },
    }),
    metaImage: '',
    facetFilter: 'features:VR support',
    segmentTitles: defineMessages({
      headsets: {
        id: 'facet-filters.vr.headsets',
        defaultMessage: 'Headsets',
      },
      input: {
        id: 'facet-filters.vr.input',
        defaultMessage: 'Input',
      },
      'play-area': {
        id: 'facet-filters.vr.play-area',
        defaultMessage: 'Play Area',
      },
      exclusive: {
        id: 'facet-filters.vr.exclusive',
        defaultMessage: 'Exclusive',
      },
    }),
    defaultFacetField: 'vr_support',
    facets: [
      {
        key: 'valve_index',
        title: 'Valve Index',
        segment: 'headsets',
      },
      {
        key: 'htc_vive',
        title: 'HTC Vive',
        segment: 'headsets',
      },
      {
        key: 'oculus_rift',
        title: 'Oculus Rift',
        segment: 'headsets',
        language: defineMessages({
          paragraph: {
            id: 'vrsupport.oculus_rift',
            defaultMessage: 'While it was a lot of people’s first foray into the world of virtual reality, the Oculus Rift was first commercially released in 2016. While its software library was limited, it is still compatible with most PC VR titles when connected to a VR-capable PC via its cables.',
          },
        }),
      },
      {
        key: 'oculus_meta_quest',
        title: 'Oculus / Meta Quest',
        segment: 'headsets',
        language: defineMessages({
          paragraph: {
            id: 'vrsupport.oculus_meta_quest',
            defaultMessage: 'The Meta Quest was the first truly standalone headset, not relying on additional sensors being set up. It has its own game store, but is also fully functional with Steam VR when plugged into a compatible PC with a Link cable, or via the Air Link feature. Games compatible with Oculus Rift will also work on the Quest, but not visa-versa.',
          },
        }),
      },
      {
        key: 'oculus_meta_quest_two',
        title: 'Oculus / Meta Quest 2',
        segment: 'headsets',
        language: defineMessages({
          paragraph: {
            id: 'vrsupport.oculus_meta_quest_two',
            defaultMessage: 'The Meta Quest 2 is the successor to the first truly standalone headset, not relying on additional sensors being set up. It has its own game store, but is also fully functional with Steam VR when plugged into a compatible PC with a Link cable, or via the Air Link feature. Games compatible with Oculus Rift will also work on the Quest 2, but not visa-versa.',
          },
        }),
      },
      {
        key: 'oculus_meta_quest_three',
        title: 'Oculus / Meta Quest 3',
        segment: 'headsets',
        language: defineMessages({
          paragraph: {
            id: 'vrsupport.oculus_meta_quest_three',
            defaultMessage: 'The Meta Quest 3 is the successor to the first truly standalone headset, not relying on additional sensors being set up. It has its own game store, but is also fully functional with Steam VR when plugged into a compatible PC with a Link cable, or via the Air Link feature. Games compatible with Oculus Rift will also work on the Quest 3, but not visa-versa.',
          },
        }),
      },
      {
        key: 'windows_mixed_reality',
        title: 'Windows Mixed Reality',
        segment: 'headsets',
      },
      {
        key: 'tracked_motion_controllers',
        title: 'Tracked Motion Controllers',
        segment: 'input',
      },
      {
        key: 'seated',
        title: 'Seated',
        segment: 'play-area',
      },
      {
        key: 'standing',
        title: 'Standing',
        segment: 'play-area',
      },
      {
        key: 'room_scale',
        title: 'Room Scale',
        segment: 'play-area',
      },
      {
        key: 'vr_required',
        title: 'VR Required',
        segment: 'exclusive',
      },
    ],
  },
};
